import React, { Component } from 'react'
import classnames from 'classnames'
import { Row, Col } from 'react-flexbox-grid'
import moment from 'moment'
import { localize } from '../../util/Localizer'
import Card from '@material-ui/core/Card'
import ConfirmationRow from '../../widgets/SubmitAClaim/confirmationRow'
import RBButton from '../../controls/RBButton'
import NgrxDate from '../../util/NgrxDateHelper'
import { clearClaim } from '../../redux/actions/submitAClaimActions'
import { submitAgain } from '../../redux/actions/submitNavigationActions'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { injectIntl } from 'react-intl'
import { formatCurrency } from '../../util/CurrencyFormatter'
import { generatePrintStylesheet } from '../../util/stylesheets'
import Config from '../../Config'
import { ClaimStatus } from '../../redux/SubmitClaim/Common'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import { withStyles } from '@material-ui/core/styles'
import { Fonts } from '../../theme'
import NgrxAuth from '../../auth/Auth'

class ClaimConfirmation extends Component {
  constructor () {
    super()
    this.submitAnother = this.submitAnother.bind(this)
    this.backToClaims = this.backToClaims.bind(this)
    this.renderHCSABody = this.renderHCSABody.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleOpen = this.handleOpen.bind(this)

    const {
      css: printCss,
      classes: printClasses
    } = generatePrintStylesheet(stylesForPrint)

    this.state = {
      open: false,
      printCss,
      printClasses
    }
  }
  handleOpen (e) {
    e.preventDefault()
    this.setState({ open: true })
  }

  handleClose () {
    this.setState({ open: false })
  }

  componentDidMount () {
    this.props.setPercent(100)
    this.props.updateUrl('')
    this.props.adjustScrollBar()
  }

  renderAuditPending () {
    const {
      AdjudicateDaysFromToday,
      staffAuditEmail,
      webAuditEmail
    } = Config
    const AdjudicateDate = NgrxDate.SetDate(moment().add(AdjudicateDaysFromToday, 'd'))
    const address = (
      <div>
        {localize('pages.SubmitAClaim.Practitioner.NexgenRXAddress.Name')}<br />
        {localize('pages.SubmitAClaim.Practitioner.NexgenRXAddress.Line2')}<br /> {/* these are out of order because nexgen wants po box first */}
        {localize('pages.SubmitAClaim.Practitioner.NexgenRXAddress.Line1')}<br />
        {localize('pages.SubmitAClaim.Practitioner.NexgenRXAddress.Line3')}
      </div>)
    const STAFF_POLICY = '0162T000'
    // staff audits are pushed to a seperate email for privacy concerns
    const auditEmail = NgrxAuth.policyNumber === STAFF_POLICY ? staffAuditEmail : webAuditEmail
    return (
      <Row className='confirmMsgRow' >
        <Col xs={12}>
          <Row middle='xs'>
            <Col xs={12} sm={8} md={6} lg={4}>
              {/* Audit claim reference number  */}
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.YourClaimHasBeenReceivedAndPendedText')} <span className='bold'>{this.props.submitClaimResult.referenceNumber}</span></p>
            </Col>
          </Row>
          <Col xs={12}>
            {/* Thank you message */}
            <Row middle='xs'><h4>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.Instructions')}</h4></Row>
            <Row middle='xs'>
              {/* Audit claim requred submit date - calculated field - current date + 21 days */}
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.InOrderForUsToContinueToAdjudicateText')}<span className='bold'>{AdjudicateDate}</span></p>
            </Row>
            {/* Audit satisfy Steps message elecrtonic/mail */}
            <Row><p>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.AdjudicateItemLine1')}</p></Row>
            {/* Electronic Response */}
            <Row middle='xs'>
              <h4>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.EResponse')}</h4>
            </Row>
            <Row middle='xs'>
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.YouCanFaxEmailOrMailText')} <span className='bold'>{this.props.submitClaimResult.referenceNumber}</span></p>
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.Email')} <a className='mainColor contactUs' href={`mailto:${auditEmail}`}>{auditEmail}</a></p>
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.EmailNote')}</p>
            </Row>
            {/* Mail Response / By Mail */}
            <Row middle='xs'>
              <h4>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.Mail')}</h4>
            </Row>
            {/* Mail Steps */}
            <Row middle='xs'>
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.MailStep1')}</p>
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.MailStep2')}</p>
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.MailStep3')}</p>
            </Row>
            <Row middle='xs'>
              <Col xs={12} sm={8} md={8} lg={8}>
                <div>{address}</div>
              </Col>
            </Row>
            <Row middle='xs'>
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.AdjudicateItemLine2')}</p>
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.AdjudicateItemLine3')}</p>
            </Row>
            {/* Audit Terms & Conditions */}
            <Row middle='xs' center='xs'>
              <a onClick={this.handleOpen} id='terms' style={{ textDecoration: 'underline' }}>{localize('common.AuditTerms')}</a>
            </Row>
          </Col>
        </Col>
      </Row>
    )
  }

  renderInProgressPending () {
    return (
      <Row className='confirmMsgRow'>
        <Col xs={12}>
          <h4>{localize('pages.SubmitAClaim.ClaimConfirmation.ProcessingClaim.PendingMessage')}</h4>
          <br />
          <Row middle='xs'>
            <Col xs={12} sm={8} md={6} lg={4}>
              <p>{localize('pages.hcsa.claimHist.claimNumber')}: <span className='bold'>{this.props.submitClaimResult.referenceNumber}</span></p>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }

  print () {
    const { printCss } = this.state
    var printConfirm = window.open('', 'PRINT', 'height=400,width=600')

    printConfirm.document.write('<html><head>')
    printConfirm.document.write(`<style>}header{}.summaryCard{margin-top:20px; padding:10px}.titledLabelTitle.reasonCode{display:none !important} a{display:none !important} .titledLabel{ display: flex; align-items:center;} .titledLabelTitle{font-weight:bold}.titledLabel p, .titledLabel div{ display:inline-block; padding:0 !important; margin:0px 0px 0px 10px !important; display:flex;}${printCss}</style>`)
    printConfirm.document.write(`</head><body style="font-family: ${Fonts.primaryFontFamily}">`)
    printConfirm.document.write(document.getElementById('confirmation').innerHTML)
    printConfirm.document.write('</body></html>')

    printConfirm.document.close() // necessary for IE >= 10
    printConfirm.focus() // necessary for IE >= 10*/

    printConfirm.print()
    printConfirm.close()
  }

  submitAnother () {
    this.props.clearClaim()
    this.props.submitAgain()
  }

  backToClaims () {
    this.props.clearClaim()
    this.props.Cancel()
    this.props.push('/Claims')
  }

  renderButtons () {
    const { classes = {} } = this.props
    const spacing = { margin: '5px 10px' }
    return (
      <Row end='md' center='xs'>
        <Col xs={12} >
          <RBButton variant='outlined' styles={spacing} label={localize('pages.SubmitAClaim.ClaimConfirmation.print')} className={classnames(classes.margin)} onClick={() => this.print()} />
          <RBButton variant='outlined' styles={spacing} label={localize('pages.SubmitAClaim.ClaimConfirmation.SubmitAnotherClaimButton')} className={classnames(classes.margin)} onClick={this.submitAnother} />
          <RBButton variant='contained' styles={spacing} label={localize('pages.SubmitAClaim.ClaimConfirmation.BackToClaimsButton')} primary className={classnames(classes.margin)} onClick={this.backToClaims} />
        </Col>
      </Row>
    )
  }

  renderHCSABody () {
    let results = this.props.submitClaimResult || []
    const total = (total, num) => Number(total) + Number(num.paidByHCSA)
    let totalPaid = results.reduce(total, 0)

    const totalLabelwithCOB = this.props.hasCOB ? { xs: 5 } : { xs: 2 }
    const totalValwithCOB = this.props.hasCOB ? { xs: 2 } : null

    let hasCOB = false
    this.props.claimObj.HCSAExpenseLines.forEach((o, i, a) => { hasCOB = o.CoordinationOfBenefitsAmount !== '' })

    return (
      <Row>
        <Col xs={12}>
          <h4>{localize('pages.SubmitAClaim.ClaimConfirmation.YourHealthCareSpendingAccountClaimHasBeenProcessed')}</h4>
          <p>{localize('pages.SubmitAClaim.ClaimConfirmation.ExplainingText3')}</p>
          <br /><br />
          {results.map((r, i) => {
            return (
              <ConfirmationRow key={i} expense={r} claim={this.props.claimObj} hasCOB={hasCOB} memberSummary={this.props.memberSummary} />
            )
          })}
          <br />
          <Row>
            <Col {...totalLabelwithCOB}>
              <Row end='xs'>
                <Col xs={12}>
                  <span className='titledLabelLabel claimid'>{localize('pages.SubmitAClaim.Expenses.Total')}</span>
                </Col>
              </Row>
            </Col>
            <Col {...totalValwithCOB}>
              <span className='titledLabelLabel claimid hcsaTotalAmount'>{formatCurrency(totalPaid || 0)}</span>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
  renderBody () {
    const { classes } = this.props
    const confirmationRowClasses = classnames(classes.confirmationRow, this.state.printClasses.confirmationRow)

    let r = this.props.submitClaimResult
    r.paidAmount = 0

    let hasCOB = false
    let claimExpenses = []

    if (this.props.EhcExpenses && this.props.EhcExpenses.length > 0) {
      claimExpenses = this.props.EhcExpenses
      for (var i = 0; i < r.claimLines.length; i++) {
        if (this.props.EhcExpenses[i] && this.props.EhcExpenses[i].COBField && this.props.EhcExpenses[i].COBField.CobAmount) {
          r.claimLines[i].coordinationOfBenefitAmount = this.props.EhcExpenses[i].COBField.CobAmount
        }
        r.claimLines[i].serviceCodeDescription = this.props.EhcExpenses[i].ExtendedHealthCareLineInfo.ServiceCodeText
        r.paidAmount += r.claimLines[i].totalPaid
        if (this.props.EhcExpenses[i].COBField) {
          hasCOB = true
        }
      }
    } else if (this.props.DentalExpenses && this.props.DentalExpenses.length > 0) {
      claimExpenses = this.props.DentalExpenses
      for (var j = 0; j < r.claimLines.length; j++) {
        if (this.props.DentalExpenses[j] && this.props.DentalExpenses[j].COBField && this.props.DentalExpenses[j].COBField.CobAmount) {
          r.claimLines[j].coordinationOfBenefitAmount = this.props.DentalExpenses[j].COBField.COBAmount
        }
        r.paidAmount += r.claimLines[j].totalPaid
        if (this.props.DentalExpenses[j].COBField) {
          hasCOB = true
        }
      }
    } else if (this.props.DrugExpenses && this.props.DrugExpenses.length > 0) {
      claimExpenses = this.props.DrugExpenses
      for (var k = 0; k < r.claimLines.length; k++) {
        if (this.props.DrugExpenses[k] && this.props.DrugExpenses[k].COBField && this.props.DrugExpenses[k].COBField.CobAmount) {
          r.claimLines[k].coordinationOfBenefitAmount = this.props.DrugExpenses[k].COBField.COBAmount
        }
        r.paidAmount += r.claimLines[k].totalPaid
        if (this.props.DrugExpenses[k].COBField) {
          hasCOB = true
        }
      }
    }

    return (
      <Row className='confirmMsgRow'>
        <Col xs={12}>
          <h4>{localize('pages.SubmitAClaim.ClaimConfirmation.YourClaimHasBeen')}</h4>
          <Row middle='xs' className={confirmationRowClasses}>
            <Col xs={12} sm={4} md={4} lg={4}>
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.YourClaimReferenceNumber')}:</p>
            </Col>
            <Col xs={12} sm={4} md={4} lg={3}>
              <p className='bold'>{r.claimCode}</p>
            </Col>
          </Row>
          <Row middle='xs' className={confirmationRowClasses}>
            <Col xs={12} sm={4} md={4} lg={4}>
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.AmountSubmitedForYourClaim')}:</p>
            </Col>
            <Col xs={12} sm={4} md={4} lg={3}>
              <p className='bold'>{formatCurrency(r.submittedAmount || 0)}</p>
            </Col>
          </Row>
          <Row middle='xs' className={confirmationRowClasses}>
            <Col xs={12} sm={4} md={4} lg={4}>
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.AmountPaidForYourClaim')}:</p>
            </Col>
            <Col xs={12} sm={4} md={4} lg={3}>
              <p className='bold'>{formatCurrency(r.paidAmount || 0)}</p>
            </Col>
          </Row>

          {(() => {
            if (this.props.memberSummary.isHCSAAvailable) {
              return (
                <Row middle='xs' className={confirmationRowClasses}>
                  <Col xs={12} sm={4} md={4} lg={4}>
                    <p>{localize('pages.SubmitAClaim.ClaimConfirmation.HSCAamountPaidForYourClaim')}:</p>
                  </Col>
                  <Col xs={12} sm={4} md={4} lg={3}>
                    {/* Need to find and add total HCSA amount */}
                    <p className='bold'>{formatCurrency(r.paidByHCSA || 0)}</p>
                  </Col>
                </Row>
              )
            }
          })()}

          <br />
          {r.claimLines ? r.claimLines.map((expense, i) => {
            return (
              <div key={i}>
                <ConfirmationRow
                  hasCOB={hasCOB}
                  expense={expense}
                  claim={this.props.claimObj}
                  eobLines={r.explanationOfBenefits}
                  ClaimExpenses={claimExpenses}
                  memberSummary={this.props.memberSummary} />
                <br />
              </div>
            )
          }) : null}
          <div style={{ fontSize: 'small' }}>
            <p>{localize('pages.SubmitAClaim.ClaimConfirmation.ExplainingText1')}</p>
            <p>{localize('pages.SubmitAClaim.ClaimConfirmation.ExplainingText2')}</p>
            <p>{localize('pages.SubmitAClaim.ClaimConfirmation.ExplainingText3')}</p>
            <p className='explainationText'>{localize('pages.SubmitAClaim.ClaimConfirmation.ExplainingText4')}</p>
          </div>
          <br />
        </Col>
      </Row>
    )
  }

  processClaimConfirmation () {
    const { claimObj, submitClaimResult } = this.props
    const showInprogressPending = ClaimStatus.isPending(submitClaimResult.claimStatus) && submitClaimResult.statusRsn !== '15'
    const showAuditPending = ClaimStatus.isPending(submitClaimResult.claimStatus) && submitClaimResult.statusRsn === '15'

    if (claimObj.HCSAExpenseLines && claimObj.HCSAExpenseLines.length > 0) {
      return this.renderHCSABody()
    }

    if (!claimObj.claimSubmitType) {
      if (showInprogressPending) {
        return this.renderInProgressPending()
      } else if (showAuditPending) {
        return this.renderAuditPending()
      } else {
        return this.renderBody()
      }
    } else {
      return this.renderInProgressPending()
    }
  }

  render () {
    const actions = [
      <RBButton
        variant='outlined'
        key='close'
        label={localize('common.close')}
        primary={false}
        onClick={this.handleClose}
      />
    ]
    return (
      <Card className='submitCard'>
        <Row start='xs'>
          <Col xs={12} id='confirmation'>
            <h3 className='confirmationHeader'>{localize('pages.SubmitAClaim.ClaimConfirmation.Title')}</h3>
            {this.processClaimConfirmation()}
          </Col>
          <Col xs={12}>
            {this.renderButtons()}
          </Col>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
          >
            <DialogTitle>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.TermsTitle')}</DialogTitle>
            <DialogContent>
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.TermsRow1')}</p>
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.TermsRow2')}</p>
              <ul>
                <li>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.TermsRow3')}</li>
                <li>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.TermsRow4')}</li>
                <li>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.TermsRow5')}</li>
              </ul>
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.TermsRow6')}</p>
              <ul>
                <li>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.TermsRow7')}</li>
                <li>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.TermsRow8')}</li>
                <li>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.TermsRow9')}</li>
                <li>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.TermsRow10')}</li>
                <li>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.TermsRow11')}</li>
                <li>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.TermsRow12')}</li>
              </ul>
              <p>{localize('pages.SubmitAClaim.ClaimConfirmation.Audit.TermsRow13')}</p>
              <DialogActions>{actions}</DialogActions>
            </DialogContent>
          </Dialog>
        </Row>
      </Card>
    )
  }
}

function mapStateToProps (state) {
  const ehcExpenses = (state.SubmitAClaimReducer.claimObj && state.SubmitAClaimReducer.claimObj.ExtendedHealthCareLines) || []
  const drugExpenses = (state.SubmitAClaimReducer.claimObj && state.SubmitAClaimReducer.claimObj.DrugClaimLines) || []
  const dentalExpenses = (state.SubmitAClaimReducer.claimObj && state.SubmitAClaimReducer.claimObj.DentalClaimLines) || []
  return {
    claimObj: state.SubmitAClaimReducer.claimObj || {},
    submitClaimResult: state.SubmitAClaimReducer.submitClaimResult || [],
    submitClaimError: state.SubmitAClaimReducer.submitClaimError || {},
    EhcExpenses: ehcExpenses,
    DrugExpenses: drugExpenses,
    DentalExpenses: dentalExpenses,
    memberSummary: state.memberSummaryReducer.memberSummary
  }
}

const ConnectedClaimConfirmation = connect(mapStateToProps, { clearClaim, submitAgain, push })(injectIntl(ClaimConfirmation))

const stylesForPrint = {
  confirmationRow: {
    // TODO: The `justifyContent` rules below are overriding a very
    // broad selector in print.css. We can remove them when print.css
    // in no longer in use.
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    '& > div': {
      flex: 1
    }
  }
}

const styles = {
  margin: {
    margin: 5
  },
  confirmationRow: {
    ['@media print']: { // eslint-disable-line no-useless-computed-key
      ...stylesForPrint.confirmationRow
    }
  }
}

export default withStyles(styles)(ConnectedClaimConfirmation)



// WEBPACK FOOTER //
// ./src/components/SubmitAClaim/ClaimConfirmation.js